import React from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../Components/Header";
import NavBar from "../Components/NavBar";
import useAuth from "../useAuth";
import { motion } from "framer-motion";
import { FaRegCopyright } from "react-icons/fa";

export default function EntryPage() {
  const { user } = useAuth();
  const location = useLocation();
  const pathname = location.pathname.split("/")[2];

  if (!user) {
    return <Navigate to="/login" />;
  }
  return (
    <div className="min-h-screen flex">
      <div className="w-72 z-30 fixed top-0 hidden lg:block">
        <div className="h-screen shadow-r-xl">
          <div className="h-[calc(100vh)] overflow-y-scroll">
            <NavBar />
          </div>
        </div>
      </div>

      <div className={`lg:ml-72 w-full bg-slate-300}`}>
        <div className="sticky z-30 top-0">
          <Header />
        </div>
        <div className="p-4 min-h-[100vh] z-10 text-gray-600 bg-gray-100">
          {<Outlet />}
        </div>
        {pathname !== "grievancesMsgs" && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="px-6 py-4 border-t border-gray-200 bg-gray-50 text-center"
          >
            <p className="flex items-center justify-center gap-1 text-[11px] text-gray-500">
              <FaRegCopyright className="text-xs" />
              {new Date().getFullYear()}{" "}
              <span className="font-semibold text-slate-700">
                BRAVISHMAH INFOTECH PRIVATE LIMITED
              </span>
              . All rights reserved.
            </p>
          </motion.div>
        )}
      </div>
    </div>
  );
}
